export const clearSelection = "vFoTe";
export default {clearSelection};